import http, { endpoints } from '../http'
import { IBranch } from '../users/models'
import { IPackageDto, IProductDto } from './dtos'
import { mapPackageFromDto, mapProductFromDto } from './helpers'
import { IPackage, IProduct } from './models'

const datahubClient = http.createClient(`${endpoints.datahub}`)

export default class PackagesApi {
	static async getPackages(branchId: IBranch['id']): Promise<IPackage[]> {
		const response = await datahubClient.get<IPackageDto[]>(`/branches/${branchId}/packages`)
		return response?.data?.map(mapPackageFromDto) || []
	}

	static async getAdditionalProducts(branchId: IBranch['id']): Promise<IProduct[]> {
		const response = await datahubClient.get<IProductDto[]>(`/branches/${branchId}/products/alacarte`)
		return response?.data?.map(mapProductFromDto) || []
	}

	static async getEmptyPackageProducts(branchId: IBranch['id']): Promise<IProduct[]> {
		const response = await datahubClient.get<IProductDto[]>(`/branches/${branchId}/products/list`)
		return response?.data?.map(mapProductFromDto) || []
	}
}
